import React, { useEffect, useState, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Pagination from "../../Reusablecomponents/Pagination";
import ExportButton from "../../Reusablecomponents/ExportButton";
import { FaEdit, FaTrash, FaPlus, FaFileExport, FaUpload, FaEye, FaTimes } from "react-icons/fa";
import "../../css/others/Table.css";
import { apiCall } from "../../main/ApiCall";
import EditAdminChecklist from "../../popups/EditAdminChecklist";
import AddAdminChecklist from "../../popups/AddAdminChecklist";
import ToastPopup from "../../popups/ToastPopup";
import axios from "axios";
import * as XLSX from 'xlsx-js-style';
import EncryptionUtils from "../../main/encryptionUtils";
import { createToastMessage, ToastMessage } from "../../interFaces/interfaces";
const AdminCheckListManagement: React.FC = () => {
  const navigate = useNavigate();
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);
  const [totalElements, setTotalElements] = useState<number>(0);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [isEditModalOpen, setIsEditModalOpen] = useState<boolean>(false);
  const [editableDetails, setEditableDetails] = useState<any>(null);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState<boolean>(false);
  const [newChecklistName, setNewChecklistName] = useState<string>("");
  const [newChecklistDescription, setNewChecklistDescription] = useState<string>("");
  const [message, setMessage] = useState<ToastMessage | null>(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
  const [deleteTemplateId, setDeleteTemplateId] = useState<string | null>(null);
  const [fields, setFields] = useState<any>({});
  const [file, setFile] = useState<File | null>(null);
  const [selectedChecklists, setSelectedChecklists] = useState<string[]>([]);
  const [selectAll, setSelectAll] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<"DRAFT" | "ACTIVE">("DRAFT");
  const [isDownloadTemplateModalOpen, setIsDownloadTemplateModalOpen] = useState<boolean>(false);
  const [, setPublishValidationModal] = useState<{ isOpen: boolean; invalidChecklists: any[] }>({ isOpen: false, invalidChecklists: [] });
  const clientId = localStorage.getItem("clientId");
  const userEmail = localStorage.getItem("email") || "";
  const fileInputRef = useRef<HTMLInputElement>(null);
  const columns = [{ key: "checkbox", label: <input type="checkbox" checked={selectAll} onChange={(e) => handleSelectAll(e.target.checked)} /> }, { key: "serialNumber", label: "S.No." }, { key: "templateName", label: "CheckList Name" }, { key: "description", label: "Description" }, { key: "checklistType", label: "Checklist Type" }, { key: "actions", label: "Action" }];
  const column = [{ key: "templateName", label: "CheckList Name" }, { key: "description", label: "Description" }, { key: "checklistType", label: "Checklist Type" }];
  useEffect(() => {
    const permissions = EncryptionUtils.get<any>("permissions", null);
    if (permissions.tabs["checkListManagement"]) {
      setFields(permissions.tabs["checkListManagement"].fields);
    }
  }, []);
  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await apiCall("get", "/api/local-templates", null, { clientId, page: currentPage - 1, size: itemsPerPage, status: activeTab });
      const { content, totalElements, totalPages } = response;
      setData(content);
      setTotalElements(totalElements);
      setTotalPages(totalPages);
      setSelectedChecklists([]);
      setSelectAll(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }, [clientId, currentPage, itemsPerPage, activeTab]);
  useEffect(() => { fetchData() }, [fetchData]);
  const fetchAllDataForExport = useCallback(async () => {
    try {
      const response = await apiCall("get", "/api/local-templates", null, { clientId, page: 0, size: totalElements, status: activeTab });
      return (
        response.content?.map((row: any) => ({ templateName: row.templateName, description: row.description, checklistType: row.isIntegratedChecklist ? "Integrated Checklist" : "Normal Checklist" })) || []
      );
    } catch (error) {
      console.error("Error exporting data:", error);
      return [];
    }
  }, [clientId, totalElements, activeTab]);
  const handleSelectChecklist = (id: string, isChecked: boolean) => {
    if (isChecked) {
      setSelectedChecklists((prev) => [...prev, id]);
    } else {
      setSelectedChecklists((prev) => prev.filter((item) => item !== id));
      setSelectAll(false);
    }
  };
  const handleSelectAll = (isChecked: boolean) => {
    setSelectAll(isChecked);
    if (isChecked) {
      const allIds = data.map((item) => item.localTemplateId);
      setSelectedChecklists(allIds);
    } else {
      setSelectedChecklists([]);
    }
  };
  const hasValidControlWeights = (checklist: any) => {
    if (!checklist.isIntegratedChecklist) return true;
    const controlWeights = checklist.controlWeights;
    if (!controlWeights || !Array.isArray(controlWeights)) {
      return false;
    }
    if (controlWeights.length === 0) {
      return false;
    }
    const validControlWeights = controlWeights.every((cw: any) => {
      if (!cw || typeof cw !== 'object') return false;
      const hasControl = cw.control && typeof cw.control === 'string' && cw.control.trim() !== '';
      const hasWeight = cw.weight !== undefined && cw.weight !== null && !isNaN(cw.weight);
      const isValidWeight = cw.weight >= 0 && cw.weight <= 100;
      return hasControl && hasWeight && isValidWeight;
    });
    const totalWeight = controlWeights.reduce((sum: number, cw: any) => sum + (cw.weight || 0), 0);
    const weightsSumTo100 = Math.abs(totalWeight - 100) < 0.01;
    return validControlWeights && weightsSumTo100;
  };
  const validateChecklistsForPublishing = () => {
    const invalidChecklists = data
      .filter(item => selectedChecklists.includes(item.localTemplateId))
      .filter(item => item.isIntegratedChecklist && !hasValidControlWeights(item))
      .map(item => {
        const controlWeights = item.controlWeights;
        let reason = "Invalid control weights configuration";
        if (controlWeights === null) {
          reason = "Control weights are null - please edit the checklist and add control weights";
        } else if (!Array.isArray(controlWeights)) {
          reason = "Control weights format is invalid - should be an array";
        } else if (controlWeights.length === 0) {
          reason = "No control weights defined - please add at least one control with weight";
        } else {
          const totalWeight = controlWeights.reduce((sum: number, cw: any) => sum + (cw.weight || 0), 0);
          const invalidItems = controlWeights.filter((cw: any) =>
            !cw || !cw.control || !cw.control.trim() || cw.weight === undefined || cw.weight === null
          );
          if (invalidItems.length > 0) {
            reason = `${invalidItems.length} control weight(s) are incomplete - check all controls have names and weights`;
          } else if (Math.abs(totalWeight - 100) >= 0.01) {
            reason = `Control weights sum to ${totalWeight}% - must total 100%`;
          } else {
            const invalidWeights = controlWeights.filter((cw: any) => cw.weight < 0 || cw.weight > 100);
            if (invalidWeights.length > 0) {
              reason = `${invalidWeights.length} control weight(s) are outside valid range (0-100)`;
            }
          }
        }
        return { templateName: item.templateName, reason: reason, controlWeights: controlWeights };
      });
    return invalidChecklists;
  };
  const getChecklistsWithoutQuestions = async () => {
    const noQuestionChecklists: string[] = [];
    for (const row of data) {
      if (selectedChecklists.includes(row.localTemplateId)) {
        try {
          const response = await apiCall("get", `/api/local-templates/${row.localTemplateId}/questions/edit`, null, { page: 0, size: 1 });
          const hasQuestions = response.content && response.content.length > 0;
          if (!hasQuestions) {
            noQuestionChecklists.push(row.templateName);
          }
        } catch {
          noQuestionChecklists.push(row.templateName);
        }
      }
    }
    return noQuestionChecklists;
  };
  const handlePublishSelected = async () => {
    if (selectedChecklists.length === 0) {
      setMessage(createToastMessage("No checklists selected.", "warning", 3000));
      return;
    }
    const noQuestionTemplates = await getChecklistsWithoutQuestions();
    if (noQuestionTemplates.length > 0) {
      setMessage(createToastMessage(`Please add questions for: ${noQuestionTemplates.join(", ")}`, "warning", 3000));
      return;
    }
    const invalidChecklists = validateChecklistsForPublishing();
    if (invalidChecklists.length > 0) {
      setPublishValidationModal({ isOpen: true, invalidChecklists });
      return;
    }
    await publishSelectedChecklists();
  };
  const publishSelectedChecklists = async () => {
    try {
      for (const localTemplateId of selectedChecklists) {
        await apiCall("post", `/api/local-templates/${localTemplateId}/publish`);
      }
      setMessage(createToastMessage("Checklists published successfully.", "success", 3000));
      fetchData();
      setPublishValidationModal({ isOpen: false, invalidChecklists: [] });
    } catch (error: any) {
      const msg = error?.response?.data?.message || "Failed to publish selected checklists.";
      setMessage(createToastMessage((msg), "error", 3000));
    }
  };
  const handleExportChecklist = async (localTemplateId: any, templateName: any, isIntegratedChecklist: boolean) => {
    try {
      const response = await apiCall("get", `/api/local-templates/${localTemplateId}/questions/edit`, null, { page: 0, size: 2_147_483_647 });
      const questions = response.content || [];
      if (questions.length === 0) {
        setMessage(createToastMessage("No questions available to export.", "warning", 3000));
        return;
      }
      const baseFields: { [key: string]: string } = { questionText: "Questions", expectedArtifact: "Expected Artifact" };
      if (!isIntegratedChecklist) {
        baseFields.practiceArea = "Control/Practice Area";
      }
      const exportData = questions.map((q: { [key: string]: any }) => {
        const row: { [key: string]: any } = {};
        for (const field in baseFields) {
          row[baseFields[field]] = q[field] ?? "";
        }
        if (isIntegratedChecklist) {
          const integratedFields: { [key: string]: string } = { pims: "PIMS", isms: "ISMS", bcms: "BCMS", cmmi: "CMMI", soc1: "SOC 1", soc2: "SOC 2", qms: "QMS", aims: "AIMS", erm: "ERM", itsm: "ITSM", ers: "ERS", ohs: "OHS" };
          for (const field in integratedFields) {
            if (q[field] && q[field].trim() !== "") {
              row[integratedFields[field]] = q[field];
            }
          }
        }
        return row;
      });
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Checklist Questions");
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${templateName}_Questions.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      setMessage(createToastMessage("Checklist exported successfully!", "success", 3000));
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || "Export failed.";
      setMessage(createToastMessage(errorMessage, "error", 3000));
    }
  };
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setFile(e.target.files[0]);
    }
  };
  const handleBulkUpload = async () => {
    if (!file || !clientId) {
      setMessage(createToastMessage("Please choose a file and ensure client ID is present.", "error", 3000));
      return;
    }
    try {
      const presignedUrl = await apiCall("get", `/api/bulk-upload/s3presigneduploadurl?fileName=${file.name}&action=checklist_creation`);
      await axios.put(presignedUrl, file, { headers: { "Content-Type": file.type } });
      const urlObj = new URL(presignedUrl);
      const fileKey = decodeURIComponent(urlObj.pathname.substring(1));
      await apiCall("post", "/api/bulk-upload/complete", { clientId, fileKey });
      await apiCall("get", "/api/bulk-upload/process-messages");
      setMessage(createToastMessage("File processed successfully!", "success", 3000));
      setFile(null);
      setTimeout(() => { window.location.reload() }, 3000);
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || "Error during bulk upload";
      setMessage(createToastMessage(errorMessage, "error", 3000));
    }
  };
  const handleDelete = (localTemplateId: string) => {
    setDeleteTemplateId(localTemplateId);
    setIsDeleteModalOpen(true);
  };
  const handleEditClick = (row: any) => {
    setEditableDetails(row);
    setIsEditModalOpen(true);
  };
  const handleSaveChanges = async (updatedData?: any) => {
    const dataToSave = updatedData || editableDetails;
    if (!dataToSave) return;
    try {
      const payload = { templateName: dataToSave.templateName, description: dataToSave.description, isIntegratedChecklist: dataToSave.isIntegratedChecklist, controls: dataToSave.controls || [], controlWeights: dataToSave.controlWeights || [], scope: dataToSave.scope || "", updatedBy: userEmail };
      await apiCall("put", `/api/local-templates/${dataToSave.localTemplateId}`, payload);
      setMessage(createToastMessage("Checklist updated successfully!", "success", 3000));
      setIsEditModalOpen(false);
      fetchData();
    } catch (error: any) {
      setMessage(createToastMessage(error?.response?.data?.message || "Error updating checklist", "error", 3000));
    }
  };
  const handleOpenCreateModal = () => { setIsCreateModalOpen(true) };
  const handleDeleteChecklist = async () => {
    if (deleteTemplateId) {
      try {
        await apiCall("delete", `/api/local-templates/${deleteTemplateId}`);
        setMessage(createToastMessage("Checklist deleted successfully!", "success", 3000));
        fetchData();
      } catch (error: any) {
        setMessage(createToastMessage((error?.response?.data?.message), "error", 3000));
      } finally {
        setIsDeleteModalOpen(false);
        setDeleteTemplateId(null);
      }
    }
  };
  const handleSaveNewChecklist = async (checklistData: { templateName: string; description: string; isIntegratedChecklist: boolean; controls: string[]; controlWeights?: { control: string; weight: number }[]; scope?: string; }) => {
    const newChecklist = { templateName: checklistData.templateName, description: checklistData.description, isIntegratedChecklist: checklistData.isIntegratedChecklist, controls: checklistData.controls, controlWeights: checklistData.controlWeights, scope: checklistData.scope, clientId: clientId, createdBy: userEmail };
    try {
      await apiCall("post", "/api/local-templates", newChecklist);
      setMessage(createToastMessage("Checklist created successfully!", "success", 3000));
      setIsCreateModalOpen(false);
      setNewChecklistName("");
      setNewChecklistDescription("");
      fetchData();
    } catch (error: any) {
      setMessage(createToastMessage((error?.response?.data?.message), "error", 3000));
    }
  };
  const handleDownloadTemplate = async (templateType: 'normal' | 'integrated') => {
    try {
      const fileName = templateType === 'normal' ? "checklist_template.xlsx" : "integrated_checklist_template.xlsx";
      const response = await apiCall("get", "/api/bulk-upload/s3presigneddownloadurl", null, { fileName, action: "default" });
      if (!response) throw new Error("Failed to retrieve presigned URL");
      const fileResponse = await axios.get(response, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([fileResponse.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setMessage(createToastMessage(`${templateType === 'normal' ? 'Normal' : 'Integrated'} template downloaded successfully.`, "success", 3000));
      setIsDownloadTemplateModalOpen(false);
    } catch (error) {
      setMessage(createToastMessage("Failed to download the template.", "error", 3000));
    }
  };
  const triggerFileInput = () => { fileInputRef.current?.click() };
  const handleNavigateToGlobalTemplates = () => {
    navigate("/globaltemplates");
  };
  const handleViewChecklistDetails = (row: any) => {
    navigate(`/adminviewchecklistdetails/${row.localTemplateId}`, {
      state: { isIntegratedChecklist: row.isIntegratedChecklist, controls: row.controls || [], },
    });
  };
  const handleAddQuestions = (row: any) => {
    navigate(`/adminchecklistdetails/${row.localTemplateId}`, {
      state: { status: activeTab, isIntegratedChecklist: row.isIntegratedChecklist, controls: row.controls || [], },
    });
  };
  return (
    <div className="table-details">
      <div className="table-title">
        <h2>Checklists</h2>
        <div className="table-title-actions">
          {fields.create && (
            <button className="create-checklist" onClick={handleOpenCreateModal}>Create Checklist</button>
          )}
          {fields.view && (
            <button onClick={() => setIsDownloadTemplateModalOpen(true)} className="checklist-download-button"> Download Template</button>
          )}
          {fields.upload && (
            <>
              <button type="button" className={`upload-checklist ${file ? "disabled" : ""}`} onClick={triggerFileInput} disabled={!!file}>Upload Checklist</button>
              <input ref={fileInputRef} type="file" accept=".csv, .xlsx, .json" onChange={handleFileChange} className="hidden-input" disabled={!!file} />
              {file && (
                <button onClick={handleBulkUpload} className="checklist-upload-button"><FaUpload />Upload File</button>
              )}
            </>
          )}
          {fields.view && (
            <button className="globaltemplates" onClick={handleNavigateToGlobalTemplates}> Global Checklists</button>
          )}
          {activeTab === "DRAFT" && (
            <button className="publish-selected" onClick={handlePublishSelected}>Publish</button>
          )}
          <ExportButton data={data} columns={column} fetchAllData={fetchAllDataForExport} fileName={`CheckLists_${activeTab}`} />
        </div>
      </div>
      <div className="tabs-container">
        <button className={`tab-button ${activeTab === "DRAFT" ? "active" : ""}`} onClick={() => setActiveTab("DRAFT")}>Draft Checklists</button>
        <button className={`tab-button ${activeTab === "ACTIVE" ? "active" : ""}`} onClick={() => setActiveTab("ACTIVE")}> Active Checklists</button>
      </div>
      <div className="table-container">
        <div className="table-inner-container">
          <table className="main-table">
            <thead>
              <tr>
                {activeTab === "DRAFT" && <th key="checkbox">{columns[0].label}</th>}
                <th key="serialNumber">{columns[1].label}</th>
                <th key="templateName">{columns[2].label}</th>
                <th key="description">{columns[3].label}</th>
                <th key="checklistType">{columns[4].label}</th>
                <th key="actions">{columns[5].label}</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={activeTab === "DRAFT" ? 6 : 5} className="no-data">Loading...</td>
                </tr>
              ) : data.length === 0 ? (
                <tr>
                  <td colSpan={activeTab === "DRAFT" ? 6 : 5} className="no-data">No data available</td>
                </tr>
              ) : (
                data.map((row, index) => (
                  <tr key={row.localTemplateId}>
                    {activeTab === "DRAFT" && (
                      <td>
                        <input type="checkbox" checked={selectedChecklists.includes(row.localTemplateId)} onChange={(e) => handleSelectChecklist(row.localTemplateId, e.target.checked)} disabled={row.isIntegratedChecklist && !hasValidControlWeights(row)} title={row.isIntegratedChecklist && !hasValidControlWeights(row) ? "Add control weights before publishing" : ""} />
                      </td>
                    )}
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td>{row.templateName}</td>
                    <td>{row.description}</td>
                    <td>
                      {row.isIntegratedChecklist ? "Integrated Checklist" : "Normal Checklist"}
                      {row.isIntegratedChecklist && !hasValidControlWeights(row) && (
                        <span className="missing-control-weights"> (Missing control weights)</span>
                      )}
                    </td>
                    <td>
                      {activeTab === "ACTIVE" && fields.view && (
                        <FaEye className="action-button" onClick={() => handleViewChecklistDetails(row)} title="View Questions" />
                      )}
                      <FaPlus className="action-button" title="Add Questions" onClick={() => handleAddQuestions(row)} />
                      {activeTab === "DRAFT" && fields.edit && (
                        <FaEdit className="action-button" title="Edit" onClick={() => handleEditClick(row)} />
                      )}
                      {activeTab === "DRAFT" && fields.delete && (
                        <FaTrash className="action-button" title="Delete" onClick={() => handleDelete(row.localTemplateId)} />
                      )}
                      <FaFileExport className="action-button" title="Export" onClick={() => handleExportChecklist(row.localTemplateId, row.templateName, row.isIntegratedChecklist)} />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Pagination currentPage={currentPage} totalPages={totalPages} totalElements={totalElements} itemsPerPage={itemsPerPage} onPageChange={setCurrentPage} onItemsPerPageChange={setItemsPerPage} />
      {isEditModalOpen && (
        <EditAdminChecklist editableDetails={editableDetails} setEditableDetails={setEditableDetails} handleSaveChanges={handleSaveChanges} onClose={() => setIsEditModalOpen(false)} />
      )}
      {isCreateModalOpen && (
        <AddAdminChecklist newChecklistName={newChecklistName} newChecklistDescription={newChecklistDescription} setNewChecklistName={setNewChecklistName} setNewChecklistDescription={setNewChecklistDescription} handleSaveNewChecklist={handleSaveNewChecklist} onClose={() => setIsCreateModalOpen(false)} />
      )}
      {isDeleteModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Are you sure you want to delete this checklist?</h3>
            <div className="buttons">
              <button className="cancelbutton" onClick={() => setIsDeleteModalOpen(false)}>Cancel</button>
              <button className="deletebutton" onClick={handleDeleteChecklist}>Yes, Delete</button>
            </div>
          </div>
        </div>
      )}
      {isDownloadTemplateModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="export-modal-header">
              <h3>Download Template</h3>
              <button className="close-button" onClick={() => setIsDownloadTemplateModalOpen(false)}><FaTimes /></button>
            </div>
            <div className="modal-body">
              <div className="template-options">
                <button className="normal-checklist" onClick={() => handleDownloadTemplate('normal')}>Normal Checklist Template</button>
                <button className="integrated-checklist" onClick={() => handleDownloadTemplate('integrated')}>Integrated Checklist Template</button>
              </div>
            </div>
          </div>
        </div>
      )}
      {message && (<ToastPopup message={message.text} type={message.type} duration={message.duration} onClose={() => setMessage(null)} />)}
    </div>
  );
};
export default AdminCheckListManagement;